var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player"},[(_vm.playCode)?_c('div',{ref:"tcplayer",staticClass:"video",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":'tcplayer' + _vm.playCode}}):_vm._e(),(_vm.playLoading)?_c('div',{staticClass:"loadingbox"},[_c('img',{attrs:{"src":require("@/assets/starting.gif"),"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }